import React from 'react';
import PropTypes from 'prop-types';
import TdsLink from '@tds/core-link';
import { Link as RouterLink } from 'react-router-dom';

import { PageWrapper } from './css';

const Page = ({ page, isSelected, url }) => {
  const elem = <PageWrapper isSelected={isSelected}>{page}</PageWrapper>;

  return (
    <>
      {isSelected ? (
        elem
      ) : (
        <TdsLink to={url} reactRouterLinkComponent={RouterLink}>
          {elem}
        </TdsLink>
      )}
    </>
  );
};

Page.propTypes = {
  page: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired
};

export default Page;
